module.exports = __webpack_public_path__ + "img/icon_water@2x.1bcdbe36.png";